(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jincheng-contact-inquiry"] && !Shopify.designMode) return;
  try {
    
  const productDirection = document.querySelector('#JinchengProductDirection');

  if (productDirection instanceof HTMLInputElement && productDirection.value.trim() === '') {
    const product = new URLSearchParams(window.location.search).get('product');

    if (product) {
      productDirection.value = product;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jincheng-homepage-motion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.documentElement;
    const cleanupTasks = [];

    function cleanup() {
      cleanupTasks.splice(0).forEach((task) => task());
      document.querySelector('.jc-home-hero__motion-media')?.remove();
      document.querySelector('.jc-home-hero')?.removeAttribute('data-jc-motion-hero');
      document.querySelector('.jc-home-hero')?.style.removeProperty('background-image');
      document.querySelectorAll('[data-jc-reveal]').forEach((element) => {
        element.removeAttribute('data-jc-reveal');
        element.classList.remove('is-visible');
        element.style.removeProperty('--jc-reveal-delay');
      });
      document.querySelectorAll('[data-jc-parallax]').forEach((element) => {
        element.removeAttribute('data-jc-parallax');
        element.style.removeProperty('--jc-parallax-y');
      });
      root.classList.remove('jc-motion-ready', 'jc-motion-low', 'jc-motion-standard', 'jc-motion-force');
    }

    function setupHero() {
      const hero = document.querySelector('.jc-home-hero');
      if (!hero) return;
      const styles = getComputedStyle(hero);
      if (styles.backgroundImage === 'none') return;
      const media = document.createElement('div');
      media.className = 'jc-home-hero__motion-media';
      media.setAttribute('aria-hidden', 'true');
      media.style.backgroundImage = styles.backgroundImage;
      media.style.backgroundPosition = styles.backgroundPosition;
      media.style.backgroundSize = styles.backgroundSize;
      media.addEventListener('animationend', () => { media.style.willChange = 'auto'; }, { once: true });
      hero.prepend(media);
      hero.setAttribute('data-jc-motion-hero', '');
    }

    function setupReveals() {
      const selectors = [
        '.jincheng-product-focus__header',
        '.jincheng-product-focus__card',
        '.jincheng-product-focus__application',
        '#main-product-lines article',
        '.jincheng-workflow__intro',
        '.jincheng-workflow__steps article'
      ];
      const elements = document.querySelectorAll(selectors.join(','));
      elements.forEach((element, index) => {
        element.setAttribute('data-jc-reveal', '');
        element.style.setProperty('--jc-reveal-delay', `${(index % 4) * 90}ms`);
      });
      if (!('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
      elements.forEach((element) => observer.observe(element));
      cleanupTasks.push(() => observer.disconnect());
    }

    function setupParallax(forceMotion) {
      const media = document.querySelectorAll('.jincheng-project-card img, .media-with-content img');
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!media.length || reduceMotion && !forceMotion) return;
      media.forEach((element) => element.setAttribute('data-jc-parallax', ''));
      let frame = 0;
      const update = () => {
        frame = 0;
        media.forEach((element) => {
          const rect = element.getBoundingClientRect();
          const progress = (rect.top + rect.height / 2 - innerHeight / 2) / innerHeight;
          element.style.setProperty('--jc-parallax-y', `${Math.max(-14, Math.min(14, progress * -18))}px`);
        });
      };
      const onScroll = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };
      addEventListener('scroll', onScroll, { passive: true });
      update();
      cleanupTasks.push(() => {
        removeEventListener('scroll', onScroll);
        if (frame) cancelAnimationFrame(frame);
      });
    }

    function init() {
      cleanup();
      const controller = document.querySelector('[data-jc-home-motion]');
      if (!controller || controller.dataset.enabled !== 'true') return;
      const forceMotion = controller.dataset.respectReducedMotion === 'false';
      root.classList.add(`jc-motion-${controller.dataset.intensity}`);
      root.classList.toggle('jc-motion-force', forceMotion);
      setupHero();
      if (controller.dataset.cardReveal === 'true') setupReveals();
      if (controller.dataset.parallax === 'true') setupParallax(forceMotion);
      requestAnimationFrame(() => root.classList.add('jc-motion-ready'));
    }

    document.addEventListener('visibilitychange', () => {
      root.classList.toggle('jc-motion-paused', document.hidden);
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('[data-jc-home-motion]')) init();
    });
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
